import './PasswordInput.css';

import React from 'react';

interface PasswordInputProps {
  label: string
  onChange: (password: string) => void
}

export const PasswordInput = ({ label, onChange }: PasswordInputProps): JSX.Element => {
  const onPasswordChanged = (event): void => { onChange(event.target.value); };

  return (
    <div id="system_password_onboarding_password_input_container">
      <div id="system_password_onboarding_password_label">{label}:</div>
      <input type="password" id="system_password_onboarding_password_input" onChange={onPasswordChanged} />
    </div>
  );
};
